import React, { HTMLProps } from 'react'
import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import Image from '../Image'

export interface StepType {
  id: string
  slug: string
}

export interface StepProps extends HTMLProps<HTMLDivElement> {
  item: StepType
}

const Step = ({ item, className }: StepProps) => {
    return (
        <div
            className={twMerge(
                'w-[calc(100vw-3rem)] md:w-[95%] flex-none text-black flex snap-start md:items-end last:mr-56 transition duration-300',
                className,
            )}
            id={`segment-${item.slug}`}
        >
            <div className='flex flex-col w-full'>
                <div className='flex flex-col lg:inline justify-center items-center text-center w-full md:items-start md:text-left border-b border-black/10 pb-3 md:pb-6'>
                    <FormattedMessage id={item.id}>
                        {(value) => <h3 className='inline'>{value}</h3>}
                    </FormattedMessage>
                    <FormattedMessage id={`${item.id}.description`}>
                        {(value) => <h3 className='hidden lg:inline opacity-60'>&nbsp;{value}</h3>}
                    </FormattedMessage>
                    <FormattedMessage id={`${item.id}.description`}>
                        {(value) => <h5 className='lg:hidden opacity-60'>{value}</h5>}
                    </FormattedMessage>
                </div>
                <div className='pt-6 md:mt-7'>
                    <div className='max-w-[480px] mx-auto lg:hidden'>
                        <Image
                            draggable={false}
                            className='object-cover w-full h-full'
                            alt={item.id}
                            slug={`${item.slug}-mobile`}
                        />
                    </div>
                    <div className='max-w-[1100px] hidden lg:block'>
                        <Image
                            draggable={false}
                            className='object-cover w-full h-full'
                            alt={item.id}
                            slug={`${item.slug}-desktop`}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Step
